module.exports = __webpack_public_path__ + "static/media/cormach_colour.73a67dcc.png";